const ZENDESK_SCRIPT_ID = 'ze-snippet';
const ZENDESK_KEY = 'ed3eb2d0-4fcf-4d9d-9d94-ecace40a4017';

export const loadZendesk = () => {
  if (document.getElementById(ZENDESK_SCRIPT_ID) || window.zE) return;
  const script = document.createElement('script');
  script.id = ZENDESK_SCRIPT_ID;
  script.src = `https://static.zdassets.com/ekr/snippet.js?key=${ZENDESK_KEY}`;
  script.async = true;
  script.addEventListener('load', () => {
    window.dispatchEvent(new CustomEvent('bb:zendesk-loaded'));
  });
  document.body.appendChild(script);
};
